<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">Sobre felinos</h4>
    <form-group :error="errors.has('cant-ataques') && submitted">
      <label class="form__label form__label--required">
        35. ¿Cuántos ataques de depredación recuerda haber tenido en su finca durante los últimos
        24 meses? (aplica para cualquier animal doméstico)?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.cantAtaques"
        id="solo-este"
        name="cant-ataques"
        v-validate="'required'"
        value="Solo este (el actual)">
        <label class="form__label" for="solo-este">Solo este (el actual)</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.cantAtaques"
        id="2ataques"
        name="cant-ataques"
        v-validate="'required'"
        value="2">
        <label class="form__label" for="2ataques">2</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.cantAtaques"
        id="3ataques"
        name="cant-ataques"
        v-validate="'required'"
        value="3">
        <label class="form__label" for="3ataques">3</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.cantAtaques"
        id="4ataques"
        name="cant-ataques"
        v-validate="'required'"
        value="4">
        <label class="form__label" for="4ataques">4</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.cantAtaques"
        id="5ataques"
        name="cant-ataques"
        v-validate="'required'"
        value="5">
        <label class="form__label" for="5ataques">5</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.cantAtaques"
        id="6ataques"
        name="cant-ataques"
        v-validate="'required'"
        value="6">
        <label class="form__label" for="6ataques">6</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.cantAtaques"
        id="7ataques"
        name="cant-ataques"
        v-validate="'required'"
        value="7">
        <label class="form__label" for="7ataques">7</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.cantAtaques"
        id="8ataques"
        name="cant-ataques"
        v-validate="'required'"
        value="8">
        <label class="form__label" for="8ataques">8</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.cantAtaques"
        id="9ataques"
        name="cant-ataques"
        v-validate="'required'"
        value="9">
        <label class="form__label" for="9ataques">9</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.cantAtaques"
        id="10ataques"
        name="cant-ataques"
        v-validate="'required'"
        value="10">
        <label class="form__label" for="10ataques">10</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.cantAtaques"
        id="+10ataques"
        name="cant-ataques"
        v-validate="'required'"
        value="Más de 10">
        <label class="form__label" for="+10ataques">Más de 10</label>
      </div>
    </form-group>

    <form-group class="identado" :error="errors.has('felino-culpable') && submitted">
      <label class="form__label form__label--required">
        35.1. ¿A cuál felino le achaca usted la culpa de todos o la mayoría de sus ataques?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.felinoCulpable"
        id="jaguar-culpable"
        name="felino-culpable"
        v-validate="'required'"
        value="Jaguar/tigre/pantera">
        <label class="form__label" for="jaguar-culpable">Jaguar/tigre/pantera</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.felinoCulpable"
        id="puma-culpable"
        name="felino-culpable"
        v-validate="'required'"
        value="Puma/león">
        <label class="form__label" for="puma-culpable">Puma/león</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.felinoCulpable"
        id="nsnr-culpable"
        name="felino-culpable"
        v-validate="'required'"
        value="NS/NR">
        <label class="form__label" for="nsnr-culpable">NS/NR</label>
      </div>
    </form-group>

    <form-group>
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="text"
      class="form__input"
      v-model="form.anoInicioAtaques">
      <label class="form__label">
        36. Solo si ha tenido más de un ataque histórico, aproximadamente ¿en qué año iniciaron los
        ataques de felinos en su finca?
      </label>
    </form-group>

    <form-group>
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="text"
      class="form__input"
      v-model="form.ultimoAtaque">
      <label class="form__label">
        37. Solo si ha tenido más de un ataque histórico, ¿el último ataque que recuerda en su finca
        fue? (el anterior a este)
      </label>
    </form-group>

    <form-group>
      <label class="form__label form__label--opcional">
        38. Solo si ha tenido más de un ataque histórico, ¿ha notado alguna época del año en que se
        den más ataques?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.epocaMasAtaques"
        id="verano"
        value="Verano">
        <label class="form__label" for="verano">Verano</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.epocaMasAtaques"
        id="invierno"
        value="Invierno">
        <label class="form__label" for="invierno">Invierno</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.epocaMasAtaques"
        id="sequias"
        value="Época de sequías">
        <label class="form__label" for="sequias">Época de sequías</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.epocaMasAtaques"
        id="temporales"
        value="Época de temporales">
        <label class="form__label" for="temporales">Época de temporales</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.epocaMasAtaques"
        id="noches-claras"
        value="Noches claras, tipo luna llena">
        <label class="form__label" for="noches-claras">Noches claras, tipo luna llena</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.epocaMasAtaquesCheckOtro"
        id="epoca-otro">
        <label class="form__label" for="epoca-otro">Otro / Comentarios adicionales</label>
      </div>
    </form-group>

    <div class="identado" v-if="form.epocaMasAtaquesCheckOtro">
      <form-group :error="errors.has('epoca-ataques-otro') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        name="epoca-ataques-otro"
        required
        v-validate="'required'"
        v-model="form.epocaMasAtaquesOtro">
        <label class="form__label">Indique cuál</label>
      </form-group>
    </div>

    <form-group :error="errors.has('han-sacrificado-felino') && submitted">
      <label class="form__label form__label--required">
        39. ¿En la zona se han visto en la necesidad de sacrificar a algún jaguar y/o puma
        anteriormente por causas de depredación?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.hanSacrificadoFelino"
        id="si-sacrificado"
        name="han-sacrificado-felino"
        v-validate="{ required: !form.hanSacrificadoFelinoCheckOtro }"
        value="Si">
        <label class="form__label" for="si-sacrificado">Sí</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.hanSacrificadoFelino"
        id="no-sacrificado"
        name="han-sacrificado-felino"
        v-validate="{ required: !form.hanSacrificadoFelinoCheckOtro }"
        value="No">
        <label class="form__label" for="no-sacrificado">No</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.hanSacrificadoFelino"
        id="nsnr-sacrificado"
        name="han-sacrificado-felino"
        v-validate="{ required: !form.hanSacrificadoFelinoCheckOtro }"
        value="NS/NR">
        <label class="form__label" for="nsnr-sacrificado">NS/NR</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.hanSacrificadoFelinoCheckOtro"
        id="otro-sacrificado">
        <label class="form__label" for="otro-sacrificado">Otro / Comentarios adicionales</label>
      </div>
    </form-group>

    <div class="identado">
      <form-group
      v-if="form.hanSacrificadoFelinoCheckOtro"
      :error="errors.has('otro-sacrificado-nombre') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        name="otro-sacrificado-nombre"
        required
        v-validate="'required'"
        v-model="form.hanSacrificadoFelinoOtro">
        <label class="form__label">Indique cuál</label>
      </form-group>

      <form-group
      v-if="form.hanSacrificadoFelino === 'Si'"
      :error="errors.has('fecha-sacrificio-felino') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        name="fecha-sacrificio-felino"
        required
        v-validate="'required'"
        v-model="form.hanSacrificadoFelinoFechas">
        <label class="form__label">¿En qué fechas/años?</label>
      </form-group>
    </div>
  </form>
</template>

<script>
export default {
  name: "FormGanadoBloque4",
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
  methods: {
    validar,
  },
};

function validar() {
  return this.$validator.validate();
}
</script>
